export const name: string = 'document';

export const types = {
    SEND_SMS: name + '/SEND_SMS',
    GET_DOC_VERSION: name + '/GET_DOC_VERSION',
    UPDATE_DOC_VERSION: name + '/UPDATE_DOC_VERSION',
    UPSERT_DOC: name + '/UPSERT_DOC',
    ACTIVATE_PARTNER_EMAIL_CONTRACT: name + '/ACTIVATE_PARTNER_EMAIL_CONTRACT',
};
